module.exports = __webpack_public_path__ + "img/detail_operation.34750727.png";